import { NgModule } from '@angular/core';
import { NavbarComponent } from 'src/app/layout/components/navbar/navbar.component';
import { NavbarVerticalStyle1Module } from 'src/app/layout/components/navbar/vertical/style-1/style-1.module';

@NgModule({
  declarations: [NavbarComponent],
  imports: [NavbarVerticalStyle1Module],
  exports: [NavbarComponent],
})
export class NavbarModule {}
